import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  footer: {
    paddingBottom: theme.spacing(3)
  }
}))

export default useStyles